import { render, staticRenderFns } from "./Courseoffer-Bottom.vue?vue&type=template&id=3332ffb1&scoped=true&"
import script from "./Courseoffer-Bottom.vue?vue&type=script&lang=js&"
export * from "./Courseoffer-Bottom.vue?vue&type=script&lang=js&"
import style0 from "./Courseoffer-Bottom.vue?vue&type=style&index=0&id=3332ffb1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3332ffb1",
  null
  
)

export default component.exports